export const safeRun =
  (errorHandler: (err: unknown) => void) =>
  <T>(fn: ((data: T) => void) | undefined, data: T) => {
    if (!fn) return;
    try {
      fn(data);
    } catch (err) {
      errorHandler(err);
    }
  };
